<template>
    <div class="container py-60">
        <div class="box-shadow pt-30 pb-40" v-if="emailLinkData">
            <div class="row justify-content-center">
                <div class="col-10">
                    <h1>Thank you!</h1>
                    <p>{{ emailLinkData }}</p>
                </div>

                <div class="col-10" v-if="actionType === 0 && showStillInterestedForm">
                    <div class="row justify-content-center">
                        <h5 class="m-5">Please give us your name and phone number so we can contact you when another user wants to share the trip, and arrange a conference call to facilitate planning. No commitment is necessary before agreement's are reached with the other Sharer.</h5>
                    </div>

                    <ValidationObserver v-slot="{ dirty, invalid }">
                        <div class="row">
                            <div class="col-12 mt-5">
                                <ValidationProvider name="Name" rules="required" v-slot="{ errors }">
                                    <div class="input-group mb-3">
                                        <input v-model="form.name" type="text" class="form-control"
                                               placeholder="Enter your name" aria-label="passenger name">
                                    </div>
                                    <div class="invalid-feedback">{{errors[0]}}</div>
                                </ValidationProvider>
                            </div>

                            <div class="col-12 mt-5">
                                <ValidationProvider name="Phone" rules="required|phoneRestriction" v-slot="{ errors }">
                                    <div class="input-group mb-3">
                                        <input v-model="form.phone" type="text" class="form-control"
                                               placeholder="Enter your phone" aria-label="passenger phone"
                                               v-mask="'(###) ###-####'">
                                    </div>
                                    <div class="invalid-feedback">{{errors[0]}}</div>
                                </ValidationProvider>
                            </div>

                            <div class="col-12 mt-2" v-if="message !== ''">
                                <div class="invalid-feedback">{{message}}</div>
                            </div>

                            <div class="col-12 text-center m-5 p-5">
                                <button class="btn btn-light-blue mx-5" @click="pairPassenger" type="button"
                                        :disabled="invalid || !dirty">
                                    Confirm
                                </button>
                            </div>
                        </div>
                    </ValidationObserver>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'

    export default {
        name: 'EmailLinks',
        data() {
            return {
                message: '',
                emailLinkData: '',
                form: {
                    name: '',
                    phone: '',
                },
                showStillInterestedForm: true
            }
        },
        computed: {
            actionType() {
                return Number(this.$route.params.action)
            },
            actionName() {
                return [
                    'still_interested',
                    'not_interested',
                    'want_to_quit'
                ][this.actionType]
            },
            hash() {
                return this.$route.params.hash
            }
        },
        mounted() {
            if (this.actionName && this.hash) {
                this.fetchEmailLinkData()
            }
            if (this.$route.params.name) {
                this.name = this.$route.params.name
            }
            if (this.$route.params.phone) {
                this.phone = this.$route.params.phone
            }
        },
        methods: {
            pairPassenger() {
                this.message = '';
                axios
                    .post(`/api/trip-match/pair_passenger/${this.hash}`, this.form)
                    .then(res => {
                        this.showStillInterestedForm = false;
                        this.$swal({title: 'Success!', icon: 'success', text: res.data})
                            .then(() => {
                                this.$router.push({name: 'TripSearch'})
                            })
                    })
                    .catch((error) => {
                        if (error.response && error.response.status === 422) {
                            if (error.response.data.errors.email) {
                                this.message = error.response.data.errors.email[0];
                            } else if (error.response.data.errors.phone) {
                                this.message = error.response.data.errors.phone[0];
                            }
                        }
                    });
            },
            fetchEmailLinkData() {
                axios
                    .get(`/api/trip-match/${this.actionName}/${this.hash}`)
                    .then(res => {
                        this.emailLinkData = res.data
                    })
                    .catch(() => {
                        this.$router.replace({path: '/'})
                    });
            }
        }
    }
</script>
